import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
function PaymentLogoAmex(_ref) {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoAmex',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFF",
    d: "M0 0H22V22H0z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#2671B9",
    fillRule: "nonzero",
    d: "M0,8.8817842e-15 L0,22 L21.9143969,22 L21.9143969,18.5625 L19.0038911,18.5625 L17.7198444,17.1875 L16.5214008,18.5625 L7.96108949,18.5625 L7.96108949,11.515625 L5.13618677,11.515625 L8.73151751,3.5234375 L12.0700389,3.5234375 L13.0116732,5.671875 L13.0116732,3.5234375 L17.0350195,3.5234375 L17.9766537,5.7578125 L18.9182879,3.5234375 L21.9143969,3.5234375 L21.9143969,8.8817842e-15 L0,8.8817842e-15 Z M19.5175097,4.640625 L18.4902724,7.1328125 L17.9766537,8.421875 L17.463035,7.1328125 L16.4357977,4.640625 L14.0389105,4.640625 L14.0389105,10.484375 L11.4708171,4.640625 L9.50194553,4.640625 L6.84824903,10.484375 L8.56031128,10.484375 L9.07392996,9.3671875 L11.8988327,9.3671875 L12.3268482,10.484375 L15.5797665,10.484375 L15.5797665,6.1015625 L15.922179,6.9609375 L17.3774319,10.484375 L18.6614786,10.484375 L20.1167315,6.9609375 L20.459144,6.1015625 L20.459144,10.484375 L22,10.484375 L22,4.640625 L19.5175097,4.640625 Z M10.1011673,6.703125 L10.4435798,5.84375 L10.7859922,6.703125 L11.385214,8.078125 L9.58754864,8.078125 L10.1011673,6.703125 Z M19.6031128,11.515625 L17.8054475,13.4921875 L16.0077821,11.515625 L14.0389105,11.515625 L16.8638132,14.5234375 L14.0389105,17.4453125 L15.922179,17.4453125 L17.7198444,15.46875 L19.5175097,17.4453125 L21.4863813,17.4453125 L18.7470817,14.4375 L21.4863813,11.515625 L19.6031128,11.515625 Z M9.15953307,11.515625 L9.15953307,17.4453125 L14.0389105,17.4453125 L14.0389105,16.15625 L10.614786,16.15625 L10.614786,15.125 L13.9533074,15.125 L13.9533074,13.8359375 L10.614786,13.8359375 L10.614786,12.8046875 L14.0389105,12.8046875 L14.0389105,11.515625 L9.15953307,11.515625 Z M20.2879377,14.4375 L21.9143969,16.15625 L21.9143969,12.8046875 L20.2879377,14.4375 Z"
  })));
}
PaymentLogoAmex.displayName = 'PaymentLogoAmex';
export default withProvisionalOverrideFromContext(PaymentLogoAmex);
//# sourceMappingURL=index.js.map